import { type BoundActions, createHook, type HookFunction } from 'react-sweet-state';

import { Store, type State, type Actions } from './store';

export const useFileUploadTrigger: HookFunction<
	State,
	BoundActions<State, Actions>,
	void
> = createHook(Store);
